// To(r)p
import apps from "./top/apps";
import contacts from "./top/contacts";
import messagingInbox from "./top/messagingInbox";
import emailInbox from "./top/emailInbox";
import insights from "./top/insights";
import secureExports from "./top/secureExports";
import teamChat from "./top/teamChat";
import engage from "./top/engage";

// Bottom
import support from "./bottom/support";
import status from "./bottom/status";
import settings from "./bottom/settings";

// 1: dev.saysimple.io, 6: spain.saysimple.io, 11: saysimple.saysimple.io, 59: demo.saysimple.io, 242: dev.saysimple-test.nl
// const internalCustomerIds = [1, 6, 11, 59, 242];

const top = [
    ...messagingInbox,
    ...emailInbox,
    ...insights,
    ...teamChat,
    ...engage,
    ...contacts,
    ...secureExports,
    ...apps,
];

const bottom = [...settings, ...support, ...status];

// Order matters
export default { top, bottom };
